import EmbeddedBlogPostVerticalCard from './EmbeddedBlogPostVerticalCard';
import EmbeddedBlogViewContainer from './EmbeddedBlogViewContainer';

export default {
  EmbeddedBlogPostVerticalCard,
  EmbeddedBlogViewContainer,
};
